import { render, staticRenderFns } from "./PartnerCallingScreen.vue?vue&type=template&id=5247fc92&scoped=true&"
import script from "./PartnerCallingScreen.vue?vue&type=script&lang=js&"
export * from "./PartnerCallingScreen.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCallingScreen.vue?vue&type=style&index=0&id=5247fc92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247fc92",
  null
  
)

export default component.exports